import { lazy } from 'react'
import { FileTextOutlined, SafetyOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import lazyComponent from './lazy'
const Content = lazy(() => import('../containers/Content'))
const Privacy = lazy(() =>
  import('../containers/Content').then((module) => ({
    default: module.PrivacyManagement,
  })),
)
const Faq = lazy(() =>
  import('../containers/Content').then((module) => ({
    default: module.FaqManagement,
  })),
)
const page = (name, url, title, Component, icon, sort) => ({
  key: `view_${name}`,
  name: `App.${name}`,
  url,
  title,
  views: { 'main@App': lazyComponent(Component) },
  data: { roles: ['PLATFORM_ADMIN'], nav: { type: 'menu', sort, icon } },
})
export default [
  page('Content', 'content', 'Términos y condiciones', Content, <FileTextOutlined />, 6),
  page(
    'ContentPrivacy',
    'content/privacy',
    'Política de privacidad',
    Privacy,
    <SafetyOutlined />,
    7,
  ),
  page(
    'ContentFaq',
    'content/faqs',
    'Preguntas frecuentes',
    Faq,
    <QuestionCircleOutlined />,
    8,
  ),
]
